import { Flex, Text } from '@mantine/core'
import { useEffect, useState } from 'react'
// import InputBudgetYear from '@components/form/input/InputBudgetYear'
// import DateAndFullNameColumn from '@components/table/DateAndFullNameColumn';
import TableViewButton from '@components/button/TableViewButton.'
import TableEditButton from '@components/button/TableEditButton'
import TableDeleteButton from '@components/button/TableDeleteButton'
import TablePagination from '@components/table/template/TablePagination'
import TableTemplate from '@components/table/template/TableTemplate'
import { ITHeadMap } from '@interfaces/ITable'
import InputCheckOwner from '@components/form/input/InputCheckOwner'
import { Link } from 'react-router-dom'
import TableAddNewButton from '@components/button/TableAddNewButton'
import { modals } from '@mantine/modals'
import { QueryObserverResult } from 'react-query'
import InputStatus from '@components/form/input/InputStatus'
import Vendor from '@api/Vendor'
import { IResponseGetAllVendors, IResponseGetAllVendorsRowData } from '@interfaces/api/IVendor'
import GroupTagBadge from '@components/badge/GroupTagBadge'
import TableSearchFilter from '@components/table/filter/TableSearchFilter'

const TableAllVendors = () => {
  const [limit, setlimit] = useState(10)
  const [orderby, setorderby] = useState<keyof IResponseGetAllVendorsRowData>('vendor_id')
  const [order, setorder] = useState('desc')
  const [page, setpage] = useState(1)
  const [search, setsearch] = useState('')
  // const [budget_year, setbudget_year] = useState('')
  const [status, setstatus] = useState('')
  const [checkowner, setcheckowner] = useState(0)
  const lists = Vendor.useGetAllVendors({
    limit,
    orderby,
    order,
    page,
    search,
    checkowner,
    // budget_year,
    status,
  })

  useEffect(() => {
    lists.refetch()
    // eslint-disable-next-line
  }, [
    status,
    // budget_year,
    page,
    limit,
    order,
    orderby,
    checkowner,
  ])

  const thead: ITHeadMap<IResponseGetAllVendorsRowData>[] = [
    {
      sortkey: 'vendor_name',
      label: 'ชื่อผู้ค้า',
      width: '30%',
    },
    {
      label: 'ประเภท',
      width: '30%',
    },
    {
      sortkey: 'status',
      label: 'สถานะ',
      width: '18%',
    },
    // {
    //     sortkey: 'created_at',
    //     label: 'สร้างเมื่อ',
    //     width: '11%',
    // },
    // {
    //     sortkey: 'updated_at',
    //     label: 'แก้ไขล่าสุด',
    //     width: '11%',
    // },
    {
      label: 'Action',
      width: '10%',
    },
  ]

  return (
    <>
      <Flex gap="md" direction={{ xs: 'column', lg: 'row' }}>
        <TableSearchFilter page={page} setpage={setpage} setsearch={setsearch} search={search} refresh={lists.refetch} />
        <InputCheckOwner
          miw="180px"
          w="100%"
          value={String(checkowner)}
          onChange={(value) => {
            if (value !== String(checkowner)) {
              setcheckowner(Number(value))
              setpage(1)
            }
          }}
        />
        <InputStatus
          withAll
          miw="180px"
          value={String(status)}
          onChange={(value) => {
            if (value !== status) {
              setstatus(String(value))
              setpage(1)
            }
          }}
        />

        {/*<InputBudgetYear*/}
        {/*  withAll*/}
        {/*  miw="200px"*/}
        {/*  value={String(budget_year)}*/}
        {/*  onChange={(value) => {*/}
        {/*    if (value !== String(budget_year)) {*/}
        {/*      setbudget_year(value!)*/}
        {/*      setpage(1)*/}
        {/*    }*/}
        {/*  }}*/}
        {/*/>*/}
        <TableAddNewButton component={Link} to="/vendors/create" label="เพิ่มผู้ค้า" />
      </Flex>

      <TableTemplate<IResponseGetAllVendorsRowData>
        thead={thead}
        orderby={orderby}
        order={order}
        setorder={setorder}
        setorderby={setorderby}
        lists={lists?.data?.lists}
      >
        {lists?.data?.lists.map((value) => <AllProjectTableRow key={value.vendor_id} data={value} refreshTable={lists.refetch} />)}
      </TableTemplate>
      {lists.data?.lists.length ? (
        <TablePagination
          limit={lists.data?.lists.length}
          setlimit={setlimit}
          setpage={setpage}
          page={page}
          totalPages={lists.data.totalPages}
          totalRows={lists.data.totalRows}
        />
      ) : (
        <></>
      )}
    </>
  )
}

export default TableAllVendors

const AllProjectTableRow = ({
  data,
  refreshTable,
}: {
  data: IResponseGetAllVendorsRowData
  refreshTable: () => Promise<QueryObserverResult<IResponseGetAllVendors, unknown>>
}) => {
  const Delete = Vendor.useDeleteVendor({
    vendor_id: data.vendor_id,
    aftersuccess: refreshTable,
  })

  const openDeleteConfirmModal = () =>
    modals.openConfirmModal({
      title: 'กรุณายืนยันการลบ',
      children: (
        <Text>
          ลบผู้ค้า/ลูกค้า <br />
          {data.vendor_name}
        </Text>
      ),
      labels: { confirm: 'ยืนยัน', cancel: 'ยกเลิก' },
      onConfirm: Delete.onSubmit,
    })

  return (
    <tr key={data.vendor_id}>
      <td>{data.vendor_name}</td>
      <td>
        <GroupTagBadge labels={data.vendor_types_name} />
      </td>
      <td>{data.status_description}</td>
      {/* <DateAndFullNameColumn
                day={data.created_at}
                fullname={data.created_by_user_fullname}
                user_id={data.created_by_user_id}
            />
            <DateAndFullNameColumn
                day={data.updated_at}
                fullname={data.updated_by_user_fullname}
                user_id={data.updated_by_user_id}
            /> */}
      <td>
        <Flex gap="xs" pos="relative">
          <TableViewButton component={Link} to={`/vendors/${data.vendor_id}/view`} />
          <TableEditButton component={Link} to={`/vendors/${data.vendor_id}/edit`} />
          <TableDeleteButton onClick={openDeleteConfirmModal} />
        </Flex>
      </td>
    </tr>
  )
}
